var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        "wap-footer": true,
        "wap-footer-border": _vm.hasBorder,
      },
    },
    [
      _vm.spver
        ? _c("div", { staticStyle: { width: "1px", height: "1px" } })
        : !_vm.spver && _vm.loadingFinished
        ? _c("footer", { staticClass: "dt-footer" }, [
            _c("a", { attrs: { href: "http://m.sogou.com" } }, [
              _vm._v("首页"),
            ]),
            _vm._v("-"),
            _c("a", { attrs: { href: "http://wap.sogou.com/web/terms.jsp" } }, [
              _vm._v("免责"),
            ]),
            _vm._v("-"),
            _c(
              "a",
              {
                attrs: { href: "https://fankui.sogou.com/wap/fb.php?fr=video" },
              },
              [_vm._v("用户反馈")]
            ),
            _vm._v(" "),
            _c("p", [_vm._v("© " + _vm._s(_vm.year) + " SOGOU.COM")]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }